import { BodyPrimary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import { getCatalogLotsListed } from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getItemSummaryIndex } from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveCatalogCurrentItemId } from '@/redux/modules/console';
import { useAppSelector } from '@/redux/hooks';
import { useCalculateNextFavorite } from './hooks/useCalculateNextFavorite';

type Props = {
    catalogId: number;
};

export const AuctionLotTracker = ({ catalogId }: Props) => {
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const totalLotsListed = useAppSelector((state) => getCatalogLotsListed(state, catalogId));
    const index = useAppSelector((state) => getItemSummaryIndex(state, itemId));

    const nextFavorite = useCalculateNextFavorite({ catalogId, itemId });
    // const bidderNextBid = useCalculateNextBid({ catalogId, itemId });

    const percent = Math.round(((index + 1) / totalLotsListed) * 100);
    const remaining = totalLotsListed - index;

    const isClose = nextFavorite && nextFavorite <= 10;

    return (
        <div className="z-10 bg-background-primary p-md transition-all duration-[2s]">
            {!isNaN(remaining) && !isNaN(totalLotsListed) && (
                <BodyPrimary>
                    <FormattedMessage
                        id="bidding_console.console.status.remaining"
                        values={{ remaining, total: totalLotsListed }}
                    />
                </BodyPrimary>
            )}
            <div className="mt-xs h-2 w-full overflow-hidden rounded-[100px] bg-surface-200 transition-all duration-300 ease-out">
                {!isNaN(percent) && (
                    <div
                        className="h-2 rounded-full bg-primary-500"
                        style={{ width: `${percent}%` }}
                    />
                )}
            </div>
            {/* {bidderNextBid !== 0 && (
                <div className="mb-2xs mt-md">
                    <H5>
                        <FormattedMessage id="bidding_console.console.status.nextBid.text" />
                    </H5>
                    <BodyPrimary className="ml-xs text-critical">
                        <FormattedMessage
                            id="bidding_console.console.status.nextBid.value"
                            values={{ total: bidderNextBid }}
                        />
                    </BodyPrimary>
                </div>
            )} */}
            {nextFavorite !== 0 && (
                // TODO: change this to !bidderNextBid when specs are written
                <div className="mt-md">
                    <H5>
                        <FormattedMessage id="bidding_console.console.status.nextFavorite.text" />
                    </H5>
                    <BodyPrimary
                        className={cn(isClose && 'text-text-critical')}
                        color="secondary"
                    >
                        <FormattedMessage
                            id="bidding_console.console.status.nextFavorite.value"
                            values={{ total: nextFavorite }}
                        />
                    </BodyPrimary>
                </div>
            )}
        </div>
    );
};
